import React from 'react'
import { Col } from 'react-grid-system'

import { SmartAuditRuleCardsProps } from './types'
import { SmartAuditRuleCard } from '../..'

const SmartAuditRuleCards = ({ data, isWorkingView, ...props }: SmartAuditRuleCardsProps) =>
   data?.map((d) => (
      <Col sm={12} xl={6} key={d.AuditID}>
         <SmartAuditRuleCard smartAuditRule={d} {...props} />
      </Col>
    )
)

export default SmartAuditRuleCards
